export default __webpack_public_path__ + "static/media/icon-check-white-border.7bb8e600.svg";